var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-pagination',{staticClass:"omapi-campaign-table__pagination",attrs:{"per-page":_vm.perPage,"page-total":_vm.campaigns.length,"total":_vm.totalFilteredCampaignsCount,"page":_vm.page},on:{"changePage":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }